// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal {
  z-index: 99999999999999;
  /* Set a high z-index value for the modal */
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/TemplateDisplay/TemplateAdvanceExportModal/TemplateAdvanceExportModal.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EAAyB,2CAAA;EACzB,eAAA;AAEF","sourcesContent":[".custom-modal {\n  z-index: 99999999999999; /* Set a high z-index value for the modal */\n  position: fixed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
